import { Component, Input, Output, EventEmitter } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

/**
 * Component for displaying task action buttons (Start/Cancel).
 */
@Component({
  selector: 'app-task-actions',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './task-actions.component.html',
  styleUrls: ['./task-actions.component.scss'],
})
export class TaskActionsComponent {
  @Input() isRunning: boolean = false;
  @Input() showStartButton: boolean = false;

  @Output() startTask = new EventEmitter<void>();
  @Output() cancelTasks = new EventEmitter<void>();

  /**
   * Emits start task event.
   */
  onStartTask(): void {
    this.startTask.emit();
  }

  /**
   * Emits cancel tasks event.
   */
  onCancelTasks(): void {
    this.cancelTasks.emit();
  }
}
